export const pillBorder = (category, selectedCategory) =>
    category === selectedCategory
        ? "transition-all delay-50 w-max py-4 px-5 md:px-6 shadow-6xl rounded cursor-pointer border-2  hover:border-Primary_Hover hover:font-semibold border-Primary_Default"
        : "transition-all delay-50 w-max py-4 px-5 md:px-6 shadow-6xl rounded cursor-pointer border-2 border-transparent hover:border-Primary_Hover hover:font-semibold";
export const pillFontWeight = (category, selectedCategory) =>
    category === selectedCategory ? "bold" : "medium";
